import React from 'react'
import SyncButton from '../../ui/sync-button'
import { regHolderBasePath } from '../../reg-holder'

const IssCasesSyncButtons = ({ regHolder, onComplete }) => (
  <SyncButton
    steps={[
      {
        syncPath: regHolderBasePath(regHolder) + '/sync-iss-cases',
      },
    ]}
    onComplete={onComplete}
  />
)

export default IssCasesSyncButtons



// WEBPACK FOOTER //
// ./src/iss-cases/views/sync-buttons.jsx